// external dependencies
import React from 'react'
import styled from '@emotion/styled'
import { MDXProvider } from '@mdx-js/tag'
import { string } from 'prop-types'
import MDXRenderer from 'gatsby-mdx/mdx-renderer'

// components
import mdxStyles from './mdx-styles'
import RfqWidget from 'components/RfqWidget'
import RfqHeader from 'components/RfqHeader'

// constants
import { COLORS, MIN_RFQ_HEIGHT, MAX_RFQ_WIDTH, MQ } from 'utils/styleHelpers'

// styled components
const WidgetWrap = styled.div`
	background: ${COLORS.WHITE};
	border-radius: 4px;
	box-shadow: 0px 3px 6px rgba(64, 63, 63, 0.2);
	margin: -30px auto 10px auto;
	max-width: 542px;
	min-height: ${MIN_RFQ_HEIGHT};
	position: relative;
	width: 100%;

	// Required for overlay when loading
	> div {
		background: white;
		display: flex;
		justify-content: center;
		width: 100%;
		z-index: 1;
	}

	${MQ.S} {
		margin-top: -80px;
		max-width: 740px;
		width: 100%;
	}

	${MQ.M} {
		max-width: ${MAX_RFQ_WIDTH.M};
	}

	${MQ.L} {
		margin-top: -120px;
		max-width: ${MAX_RFQ_WIDTH.L};
	}
`

// prop-types
const propTypes = {
	rfqMdx: string.isRequired,
}

const SectionRfq = ({ rfqMdx }) => {
	return (
		<WidgetWrap>
			<MDXProvider components={mdxStyles}>
				<MDXRenderer scope={{ RfqHeader, RfqWidget }}>{rfqMdx}</MDXRenderer>
			</MDXProvider>
		</WidgetWrap>
	)
}

SectionRfq.propTypes = propTypes

export default SectionRfq
